import React from 'react'
import { useRouteMatch } from 'react-router'
import { Container } from '@mui/material'
import { Route, Switch } from 'react-router-dom'
// import SubsidiaryAccounts from './SubsidiaryAccounts/SubsidiaryAccounts'

interface IEditorAppData{
  user?:any
}

const SubsidiaryApp: React.FC<IEditorAppData> = () => {
  const { path } = useRouteMatch()

  return (
    <Container maxWidth='xl'>
      <Switch>
        <Route path={`${path}/accounts`}>
          {/* <SubsidiaryAccounts /> */}
        </Route>
      </Switch>
    </Container>
  )
}
export default SubsidiaryApp
